import { render, staticRenderFns } from "./TimeTable.vue?vue&type=template&id=bed110aa&"
import script from "./TimeTable.vue?vue&type=script&lang=js&"
export * from "./TimeTable.vue?vue&type=script&lang=js&"
import style0 from "./TimeTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
